// Central legal / business-identity constants used by the Privacy, Terms, and
// SMS Consent pages and the footer. Keep these consistent with what is submitted
// to Twilio toll-free verification and with official business records — a mismatch
// is what gets a verification rejected (reason codes 30484 / 30445).
//
// Sourced from the Minnesota Articles of Organization (filed 2019-12-24) and the
// IRS CP 575 EIN notice. The state filing name is the authoritative legal name.
export const LEGAL = {
  // Exact registered legal entity that operates Photodrop — matches the Minnesota
  // Articles of Organization, Article I. Use this verbatim on the Twilio submission.
  entity: 'MiddleOut, LLC',
  product: 'Photodrop',
  domain: 'photodrop.dev',
  supportEmail: 'support@photodrop.dev',
  // Registered office (MN Articles of Organization, Article II).
  address: '3730 Shady Oak Road, Minnetonka, MN 55305',
  // Governing law for the Terms — state of formation.
  governingState: 'Minnesota',
  effectiveDate: 'July 21, 2026',
} as const

export const LEGAL_ENTITY_DISPLAY = `${LEGAL.product} is a product of ${LEGAL.entity}.`
